import { HeadingDesc, HeadingDescVsmall } from '../../Headings';
import uploadIcon from '../../../assets/images/png/upload.png';
import './uploadInput.css';

function UploadInput(props) {
  const { onChange } = props;
  return (
    <div className="uploadInput">
      <div>
        <HeadingDesc text="Upload File" />
        <HeadingDescVsmall text="Format can be in JPG, PNG or PDF. File size needs to be Mac 3MB." />
      </div>
      <div>
        <input id="icon-button-file" multiple type="file" onChange={onChange} />
        <label htmlFor="icon-button-file">
          <img src={uploadIcon} alt="uploadIcon" />
        </label>
      </div>
    </div>
  );
}

export default UploadInput;
